/* eslint-disable no-case-declarations */
/* eslint-disable no-undefined */
import useStyles from "../styles";
import { Grid } from "@mui/material";
import InputGroup from "../../../components/FormComponent/InputGroup";
import Button from "../../../components/Button";
import { useEffect, useState } from "react";
import { httprequest } from "../../../data/api";
import { toast } from "react-toastify";
import PageLoader from "../../../components/PageLoader";
import emptynotification from "../../../assets/images/Empty State.png";
import NoData from "../../dashboard/components/NotFoundCard/NoData";
import TextAreaGroup from "../../../components/FormComponent/TextAreaGroup";

const CUSTOM_FIELDS_ENDPOINT = "api/v1/custom-fields";
const CUSTOM_FIELDS_VALUES_ENDPOINT = "api/v1/custom-fields/values";

const AdditionalFields = ({ data, targetType = "school_profile" }) => {
  const classes = useStyles();
  const [isLoading, setIsLoading] = useState(false);
  const [isFetching, setIsFetching] = useState(false);
  const [customFields, setCustomFields] = useState([]);
  const [fieldValues, setFieldValues] = useState({});

  const fetchCustomFields = () => {
    setIsFetching(true);

    httprequest.get(`${CUSTOM_FIELDS_ENDPOINT}?scope=${targetType}`)
      .then((res) => {
        setIsFetching(false);

        const fields = res.data?.data?.fields;

        if (fields && Array.isArray(fields)) {
          setCustomFields(fields);

          const initialValues = {};
          fields.forEach(field => {
            let existingValue = "";

            if (field.values && Array.isArray(field.values) && field.values.length > 0) {
              const firstValue = field.values[0];
              if (firstValue && firstValue.value !== undefined) {
                existingValue = firstValue.value;
                if (Array.isArray(existingValue)) {
                  existingValue = existingValue.join(", ");
                }
              }
            }

            initialValues[field.id] = existingValue;
          });

          setFieldValues(initialValues);
        } else {
          setCustomFields([]);
          setFieldValues({});
        }
      })
      .catch(() => {
        setIsFetching(false);
        toast.error("Failed to load custom fields");
        setCustomFields([]);
        setFieldValues({});
      });
  };

  useEffect(() => {
    if (targetType) {
      fetchCustomFields();
    }
  }, [targetType]);

  const handleFieldChange = (fieldId, value) => {
    setFieldValues(prev => ({
      ...prev,
      [fieldId]: value
    }));
  };

  const handleUpdateCustom = () => {
    setIsLoading(true);

    const valuesPayload = Object.entries(fieldValues)
      .map(([fieldId, value]) => {
        let formattedValue = [];

        if (typeof value === "string") {
          if (value.trim() !== "") {
            formattedValue = [value];
          }
        } else if (typeof value === "number") {
          formattedValue = [value.toString()];
        } else if (value !== undefined && value !== null && value !== "") {
          formattedValue = [value.toString()];
        }

        return {
          field_id: fieldId,
          value: formattedValue
        };
      });

    const payload = {
      target_type: targetType,
      target_id: data?.school_id,
      values: valuesPayload
    };

    httprequest.patch(CUSTOM_FIELDS_VALUES_ENDPOINT, payload)
      .then((response) => {
        setIsLoading(false);
        toast.success(response?.data?.message || "Custom fields updated successfully");
        fetchCustomFields();
      })
      .catch((error) => {
        setIsLoading(false);
        toast.error(error.response?.data?.message || "Failed to update custom fields");
      });
  };

  const renderFieldInput = (field) => {
    const value = fieldValues[field.id] || "";

    const isEditable = true;

    const commonProps = {
      label: field.name + (field.is_required ? " *" : ""),
      inputName: `field_${field.id}`,
      value,
      placeholder: field.description || field.help_text || `Enter ${field.name.toLowerCase()}`,
      onChange: (e) => handleFieldChange(field.id, e.target.value),
      required: field.is_required,
      disabled: !isEditable
    };

    switch (field.field_type?.toLowerCase()) {
    case "textarea":
      return (
        <TextAreaGroup {...commonProps}
          rows={4}
          placeholder="Type your reply..."
        />
      );

    case "number":
      return (
        <InputGroup
          inputType="number"
          {...commonProps}
          min={field.validation_rule === "min" ? field.custom_regex : undefined}
          max={field.validation_rule === "max" ? field.custom_regex : undefined}
        />
      );

    case "date":
      return <InputGroup inputType="date" {...commonProps} />;

    case "text":
    default:
      return <InputGroup inputType="text" {...commonProps} />;
    }
  };

  return (
    <Grid container spacing={4}>
      <Grid item lg={3} md={4} sm={12} xs={12}>
        <div className="left-container">
          <h4>Additional Fields</h4>
          <h6>Fill in additional information specific to this record</h6>
        </div>
      </Grid>
      <Grid item lg={9} md={8} sm={12} xs={12}>
        <div className="right-container">
          {isFetching ? (
            <div><PageLoader /></div>
          ) : customFields.length === 0 ? (
            <div className="page-content" style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
              <div className={classes.notfound}>
                <NoData title="Empty Additional Field"
                  subtitle="No Additional field found."
                  img={emptynotification}
                />
              </div>
            </div>
          ) : (
            <>
              {customFields.map((field) => (
                <Grid
                  container
                  spacing={2}
                  className={classes.profileform}
                  key={field.id}
                  alignItems="center"
                  style={{ marginBottom: "20px" }}
                >
                  <Grid item lg={12} md={12} sm={12} xs={12}>
                    {renderFieldInput(field)}
                    {field.description && (
                      <small className={classes.helpText} style={{ display: "block", marginTop: "5px", color: "#666" }}>
                        {field.description}
                      </small>
                    )}
                    {field.help_text && (
                      <small className={classes.helpText} style={{ display: "block", marginTop: "5px", color: "#888", fontSize: "12px" }}>
                        {field.help_text}
                      </small>
                    )}
                  </Grid>
                </Grid>
              ))}

              <div className={classes.btnspace}>
                <Button
                  variant="primary"
                  color="btndefault"
                  buttonSize="medium"
                  buttonName="Save Changes"
                  isLoading={isLoading}
                  onClick={handleUpdateCustom}
                  disabled={isLoading || customFields.length === 0}
                />
              </div>
            </>
          )}
        </div>
      </Grid>
    </Grid>
  );
};

export default AdditionalFields;
